import { getObjectWithOverlayStorageId, useAllSavedFunnels } from '@fullstory/redux';
import { useMemo } from 'react';

export const useFunnelOverlay = (funnelId: string, overlayHash?: string) => {
  const { byId: funnelsById } = useAllSavedFunnels(true);
  const funnelStorageId = overlayHash
    ? getObjectWithOverlayStorageId(funnelId, overlayHash)
    : funnelId;

  const savedFunnelDetail = useMemo(
    () => (funnelStorageId ? funnelsById?.[funnelStorageId] ?? null : null),
    [funnelStorageId, funnelsById],
  );
  const savedFunnelRecord = savedFunnelDetail?.funnel ?? null;
  const savedFunnelSettings = savedFunnelRecord?.funnel?.funnelSettings;

  return {
    funnelRecord: savedFunnelRecord,
    funnelSettings: savedFunnelSettings,
    funnelDetail: savedFunnelDetail,
  };
};
